import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Img from "gatsby-image"

export default ({ data }) => {
  const post = data.markdownRemark
  let featuredImgFluid = post.frontmatter.featuredImage.childImageSharp.fluid
  return (
    <Layout>
      <SEO title= {post.frontmatter.title} description={post.excerpt}/>
      <div className="hero is-medium has-background">
          <div class="hero-background">
            <Img fluid={featuredImgFluid} />
          </div>
          <div className="hero-head" style={{ paddingLeft: 20 }}>
            <Link to="/" className="button is-rounded" style={{ marginTop: 40 }}>All Articles</Link>
          </div>
          <div className="hero-body">
              <div className="container">
                <h1 className="title is-1">{post.frontmatter.title}</h1>
              </div>
          </div>
      </div>
      <div style={{ backgroundColor: '#fff' }}>
        <div className="container">
          <div className="section">
            <div className="content">
              <p className="subtitle is-size-6 has-text-grey-light">Created on {post.frontmatter.date}</p>
              <div style={{marginTop: 15, marginBottom: 35}}>
                  {post.frontmatter.tags.map((tag, index) => (
                      <span key={index} className="tag is-link is-light" style={{marginRight: 5}}>{tag}</span>
                  ))}
              </div>
              <div className="has-text-grey" dangerouslySetInnerHTML={{ __html: post.html }} />
              
              <div className="level" style={{marginTop: '4rem'}}>
                <div className="level-left">
                  <img 
                    src="/joseph.png" 
                    style={{border: 0, height: 'auto', outline: 'none', textDecoration: 'none', marginRight: 10}}
                    width="40" height="40"/>
                  <span>
                    Written by <a href="https://www.linkedin.com/in/jokhan/" target="_blank" rel="noreferrer nofollow noopener" aria-label="This is an external link (opens in a new tab)">
                      <strong>{post.frontmatter.author}</strong>
                    </a>
                  </span>
                </div>
              </div>
              <hr className="hr"/>
              <div>
                <p className="has-text-grey"><strong>Sharing is caring</strong></p>
                <div className="level is-mobile">
                    <div className="level-left">
                        <div className="level-item">
                            <img 
                            src="/color-facebook-48.png" 
                            alt="LoremText Facebook Page" 
                            style={{border: 0, height: 'auto', outline: 'none', textDecoration: 'none'}} 
                            width="24" height="24"/>
                        </div>
                        <div className="level-item">
                            <img 
                            src="/color-twitter-48.png" 
                            alt="LoremText Twitter Page" 
                            style={{border: 0, height: 'auto', outline: 'none', textDecoration: 'none'}} 
                            width="24" height="24"/>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      excerpt
      frontmatter {
        title
        tags
        author
        date(formatString: "MMM DD, YYYY")
        featuredImage {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`